import type { HTMLAttributes } from 'react'

import { Icon, type IconName } from './Icon'
import styles from './EmptyState.module.css'

export interface EmptyStateProps extends HTMLAttributes<HTMLDivElement> {
  icon?: IconName
  title: string
  text: string
}

export function EmptyState({ icon = 'search', title, text, className = '', ...props }: EmptyStateProps) {
  return (
    <div className={`${styles.empty} ${className}`} {...props}>
      <Icon className={styles.icon} name={icon} size={52} strokeWidth={1.5} />
      <h4 className={styles.title}>{title}</h4>
      <p className={styles.text}>{text}</p>
    </div>
  )
}
